import { getContext, select, throttle } from 'redux-saga/effects';
import { playNotificationSound } from '../actions/global';
import { dateDiff } from '@wix/da-ds/pkg/Time/functions';
import { getIsSoundDisabled } from '../selectors/settings';
import { Howl } from 'howler';

function* handlePlayNotificationSound(
  action: ReturnType<typeof playNotificationSound>
) {
  const soundsDisabled = yield select(getIsSoundDisabled);
  if (soundsDisabled) {
    return;
  }

  const now = new Date(Date.now());
  // Only play events that just happened, this fixes throttle sending the last event
  // after 10s, logic being you don't want to know about something that happened 10s ago
  if (
    dateDiff(now.toISOString(), action.payload.date.toISOString(), 'seconds') <
    2
  ) {
    const howlerInstance: Howl = yield getContext('howlerInstance');
    howlerInstance.play();
  }
}

export function* chatSoundSaga() {
  // No more than one sound every one minute
  yield throttle(10_000, playNotificationSound, handlePlayNotificationSound);
}
